import React from 'react';
import { Button } from '../../../ui';

const BLOCKING_REASON_MESSAGES = {
  line_engine_missing: 'No pudimos encontrar el análisis de línea necesario para generar una oferta.',
  line_engine_warning: 'El análisis de línea requiere revisión antes de continuar.',
  line_engine_rejected: 'La solicitud no tiene una línea habilitada para continuar.',
  line_engine_not_ready: 'La solicitud no puede continuar por el momento.',
  request_rejected: 'La solicitud no puede continuar porque fue rechazada.'
};

const getBlockingMessage = (blockingReason) => (
  BLOCKING_REASON_MESSAGES[blockingReason] || 'La solicitud no puede continuar por el momento.'
);

const ResumeBlockedStep = ({
  blockingReason,
  onFatalError,
  onViewRequests
}) => (
  <div className="container py-4">
    <div className="card border-0 shadow-sm">
      <div className="card-body text-center p-4">
        <h2 className="h5 mb-3">No se puede continuar</h2>
        <p className="text-muted mb-4">{getBlockingMessage(blockingReason)}</p>
        <div className="d-flex justify-content-center gap-2 flex-wrap">
          {typeof onFatalError === 'function' && (
            <Button variant="primary" onClick={onFatalError}>
              Volver al perfil
            </Button>
          )}
          {typeof onViewRequests === 'function' && (
            <Button variant="outlineSecondary" onClick={onViewRequests}>
              Ver solicitudes
            </Button>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default ResumeBlockedStep;
